export const convertNullishToEmptyString = value => {
  if (!value || value === 'undefined' || value === 'null') {
    return '';
  } else {
    return value;
  }
};
